import React, { useState, useEffect } from 'react';
import { useTranslation } from '../context/TranslationContext';
import HowItWorks from './HowItWorks';
import WhyTeamsLove from './WhyTeamsLove';
import WhoBenefits from './WhoBenefits';
import PricingSection from './PricingSection';
import AboutUs from './AboutUs';
import OurValues from './OurValues';
import GetInTouch from './GetInTouch';
import Footer from './Footer';
import '../styles/LandingPage.css';

interface LandingPageProps {
  onLogin: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onLogin }) => {
  const { t } = useTranslation();
  const [displayText, setDisplayText] = useState('');
  const [showSubtitle, setShowSubtitle] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showCursor, setShowCursor] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const fullText = 'Your AI RFQ Agent';
  
  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index <= fullText.length) {
        setDisplayText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(timer);
        // Başlık bittikten sonra cursor'ı gizle ve alt başlığı göster
        setShowCursor(false);
        setTimeout(() => {
          setShowSubtitle(true);
          // Alt başlık gösterildikten sonra butonu göster
          setTimeout(() => {
            setShowButton(true);
          }, 500);
        }, 300);
      }
    }, 60); // Her 60ms'de bir harf (daha hızlı)

    return () => clearInterval(timer);
  }, []);

  // Dark mode detection
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsDarkMode(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className="landing-page">
      {/* Animated Background - Fixed for entire page */}
      <div className="animated-background">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="floating-shape shape-5"></div>
      </div>

      {/* Header */}
      <header className="landing-header">
        <div className="header-left">
          <div className="logo">
            <img 
              src="/favicon-32x32-white.png" 
              alt="GordianRFQ Logo" 
              className="logo-icon"
            />
            <span className="logo-text">RFQ Agent</span>
          </div>
        </div>
        <nav className="header-nav">
          <button className="nav-link" onClick={() => document.querySelector('.how-it-works')?.scrollIntoView({ behavior: 'smooth' })}>
            Features
          </button>
          <button className="nav-link" onClick={() => document.querySelector('.pricing-section')?.scrollIntoView({ behavior: 'smooth' })}>
            Pricing
          </button>
          <button className="nav-link" onClick={() => document.querySelector('.about-us')?.scrollIntoView({ behavior: 'smooth' })}>
            About
          </button>
          <button className="nav-link" onClick={() => document.querySelector('.get-in-touch')?.scrollIntoView({ behavior: 'smooth' })}>
            Contact
          </button>
          <button className="login-btn" onClick={onLogin}>
            Sign In
          </button>
        </nav>
      </header>

      {/* Main Content */}
      <main className="landing-main">
        <div className="content-container">
          {/* Main Headline */}
          <h1 className="main-headline">
            <span className={`headline-line ${showCursor ? 'with-cursor' : ''}`}>{displayText}</span>
          </h1>

          {/* Sub-headline */}
          <p className={`sub-headline ${showSubtitle ? 'fade-in-up' : ''}`}>
            From the need to the quote at a click!
          </p>

          {/* CTA Buttons */}
          <div className={`cta-buttons ${showButton ? 'fade-in-up' : ''}`}>
            <button className="cta-primary" onClick={onLogin}>
              Get Started
            </button>
          </div>
        </div>
      </main>

      {/* How It Works Section */}
      <HowItWorks />
      
      {/* Why Teams Love Section */}
      <WhyTeamsLove />
      
              {/* Who Benefits Section */}
        <WhoBenefits />
        {/* Pricing Section */}
        <PricingSection />
        {/* About Us Section */}
        <AboutUs />
        {/* Our Values Section */}
        <OurValues />
        {/* Get in Touch Section */}
        <GetInTouch />
        
        {/* Footer */}
        <Footer />
      </div>
    );
  };

export default LandingPage;
